import { Button, Col, Flex, Form, InputNumber, Popconfirm, Row, Table, Image } from 'antd';
import React, { Component } from 'react';
import { ChoiceTypeEnum, GameStatusEnum, IGameItem } from '../store/game.types';
import Text from 'antd/es/typography/Text';
import dayjs from 'dayjs';
import { ChoiceGroup, ResultChoice } from '../components';
import { SafetyOutlined } from '@ant-design/icons';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';
import { observer } from 'mobx-react';
import { AppContext, AppContextValue } from '../../../theme/AppContextProvider';
import { getImageUrl } from '../../../utils';
import { ReactComponent as PlayIcon } from '../assets/play.svg';
import { ReactComponent as ChanelIcon } from '../assets/chanel.svg';

class _GamesTable extends Component<IRootStoreProps> {
  static contextType = AppContext;
  render() {
    const { globalTheme } = this.context as AppContextValue;
    const {
      listGames,
      updateChoiceGame,
      update,
      handleTableChange,
      getGamesParams,
      newGame,
      total,
      getLastGames,
      showCurrentGames,
      showLastGames,
      setFilterAmount,
    } = this.props.store.game;
    const pagination = { total: total, pageSize: getGamesParams.limit };
    const columns = [
      {
        title: 'Имя',
        dataIndex: 'ownerName',
        key: 'ownerName',
        render: (name: string, item: IGameItem, index: number) => {
          const valueChoice = item?.isOwner ? item?.ownerChoice : item.selectedChoice;
          const isDisabled = item.status !== GameStatusEnum.CREATED;
          const isCanceled = item.status === GameStatusEnum.CANCELED;
          const isFinished = item.status === GameStatusEnum.FINISHED;
          const betColor = isCanceled
            ? globalTheme?.colorBorder
            : index % 2 === 0
              ? globalTheme?.blue6
              : globalTheme?.red5;
          return (
            <Row style={{ borderRadius: 8, marginBottom: 8, marginInline: 8, backgroundColor: '#F7F7F7' }}>
              <Col
                span={4}
                style={{
                  borderTopLeftRadius: 8,
                  borderBottomLeftRadius: 8,
                  backgroundColor: '#F2F2F2',
                  padding: 7,
                }}
              >
                <Flex vertical justify={'center'} align={'center'}>
                  <Text style={{ fontWeight: 600, fontSize: 12 }}>СТАВКА</Text>
                  <Text style={{ fontWeight: 600, fontSize: 20, color: item.colorResult || betColor }}>
                    {item.betAmount}
                  </Text>
                </Flex>
              </Col>
              <Col span={20}>
                {isFinished ? (
                  <Flex align={'center'} style={{ height: '100%', paddingInline: 10 }}>
                    <ResultChoice game={item} />
                  </Flex>
                ) : (
                  <Row
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      paddingInline: 10,
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    <Col>
                      <Image src={getImageUrl(item.ownerId)} width={30} />
                      <Text style={{ fontWeight: 400, fontSize: 16, marginLeft: 5 }}>{item.ownerName}</Text>
                    </Col>
                    <Flex vertical>
                      <Text>{dayjs(item.createdAt).format('HH:mm')}</Text>
                      <Text type={'secondary'} style={{ fontSize: 12, marginTop: -3 }}>
                        {dayjs(item.createdAt).format('DD MMMM')}
                      </Text>
                    </Flex>
                    <Popconfirm title={'Hash для проверки честности игры'} description={item.md5}>
                      <Button
                        type={'text'}
                        style={{ color: globalTheme?.green5 }}
                        icon={<SafetyOutlined width={40} height={40} />}
                      />
                    </Popconfirm>
                    <ChoiceGroup
                      value={valueChoice}
                      onChange={(id?: ChoiceTypeEnum) => updateChoiceGame(item.gameId, id)}
                      style={{ height: 36 }}
                      disabled={item.isOwner}
                      type={newGame.type}
                      isOdd={!!(index % 2)}
                    />
                    <Button
                      style={{ height: 40, width: 48, borderRadius: 11, borderWidth: 0, backgroundColor: betColor }}
                      onClick={() => update(item?.gameId)}
                      disabled={isDisabled}
                      icon={item.isOwner ? <ChanelIcon /> : <PlayIcon style={{}} />}
                    />
                  </Row>
                )}
              </Col>
            </Row>
          );
        },
      },
    ];

    const buttonTitle = showLastGames ? 'Текущие игры' : 'Последние 100 игр';
    const getGames = showLastGames ? showCurrentGames : getLastGames;
    const refreshGames = !showLastGames ? showCurrentGames : getLastGames;

    return (
      <>
        <Flex justify={'space-between'} style={{ paddingBottom: 10 }}>
          <Form name="horizontal_filter" layout="inline" onFinish={setFilterAmount}>
            <Form.Item name="minBetAmount" label="Сумма от:" rules={[{ required: true, message: 'Введите от!' }]}>
              <InputNumber min={0} step={1} />
            </Form.Item>
            <Form.Item name="maxBetAmount" label="до:" rules={[{ required: true, message: 'Введите до!' }]}>
              <InputNumber min={0} step={1} />
            </Form.Item>
            <Form.Item shouldUpdate>{() => <Button htmlType="submit">{'Применить'}</Button>}</Form.Item>
          </Form>
          <Col>
            <Button type={'link'} onClick={getGames}>
              {buttonTitle}
            </Button>
            <Button type={'link'} onClick={refreshGames}>
              {'Обновить'}
            </Button>
          </Col>
        </Flex>
        <Table
          showHeader={false}
          dataSource={listGames.map((game: any) => ({ ...game, key: game.gameId }))}
          columns={columns}
          pagination={pagination}
          onChange={handleTableChange}
        />
      </>
    );
  }
}

export const GamesTable: WithoutStore = withStore(observer(_GamesTable));
